import { HttpErrorResponse } from "@angular/common/http";
import { DEFAULT_ERROR_MESSAGE } from "@constants";

export const getHttpErrorMessage = (error: HttpErrorResponse): string => {
  if (!error) return DEFAULT_ERROR_MESSAGE;

  return error.error?.response?.message?.toString() || error.error?.message;
};
